<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import type { LetterSelectionDraft, LetterSelectionRow } from "../../contract"
  import LetterOrderTag from "../../../../_shared/_modules/letter-order-tag"
  let props: InboxWorkflowCellProps<LetterSelectionRow, LetterSelectionDraft> = $props()
</script>
<LetterOrderTag row={props.row} />
